var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurplecsvDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.75,
    height: 16.75,
    viewBox: "0 0 16.75 16.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-1.625 -4.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13121",
    "data-name": "Group 13121",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13014",
    "data-name": "Path 13014",
    d: "M2.625,29.7a.637.637,0,0,1,.625.647v3.237A1.273,1.273,0,0,0,4.5,34.88h11a1.273,1.273,0,0,0,1.25-1.295V30.347a.625.625,0,1,1,1.25,0v3.237a2.546,2.546,0,0,1-2.5,2.59H4.5A2.546,2.546,0,0,1,2,33.585V30.347A.637.637,0,0,1,2.625,29.7Z",
    transform: "translate(0 -18.175)",
    fill: "#600097",
    stroke: "#600097",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13015",
    "data-name": "Path 13015",
    d: "M17.431,17.056a.61.61,0,0,0,.885,0l3.75-3.885a.665.665,0,0,0,0-.917.611.611,0,0,0-.885,0L18.5,15.034V5.647a.625.625,0,1,0-1.25,0v9.387l-2.682-2.78a.611.611,0,0,0-.885,0,.665.665,0,0,0,0,.917Z",
    transform: "translate(-7.874 -3)",
    fill: "#600097",
    stroke: "#600097",
    strokeWidth: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplecsvDownload);
export default __webpack_public_path__ + "static/media/Purple csv- Download.5c3c0aa5133412c02507c3c8f73b53aa.svg";
export { ForwardRef as ReactComponent };